<template>
  <VaccinationPage
    title="Chronic Liver Disease"
    :buttons="buttons"
    baseRoute="/ChronicLiverSecondPage"
    :bottomImage="require('@/assets/page22/Asset 208.png')"
    :footerBanner="require('@/assets/page4/lowererPanner.png')"
    prevRoute="/vaccination"
    nextRoute="/ChronicLiverSecondPage"
  />
</template>

<script setup>
import VaccinationPage from "@/components/VaccinationPage.vue";

const buttons = [
  { imgPath: require("@/assets/page22/Asset 195.png"), name: "Influenza" },
  { imgPath: require("@/assets/page22/Asset 196.png"), name: "Pneumococcal" },
  { imgPath: require("@/assets/page22/Asset 197.png"), name: "RSV" },
  { imgPath: require("@/assets/page22/Asset 198.png"), name: "COVID-19" },
  { imgPath: require("@/assets/page22/Asset 199.png"), name: "HepatitisA" },
  { imgPath: require("@/assets/page22/Asset 200.png"), name: "HepatitisB" },
  { imgPath: require("@/assets/page22/Asset 201.png"), name: "Zoster" },
  { imgPath: require("@/assets/page22/Asset 202.png"), name: "MMR" },
  { imgPath: require("@/assets/page22/Asset 203.png"), name: "Varicella" },
  { imgPath: require("@/assets/page22/Asset 204.png"), name: "Tetanus" },
  { imgPath: require("@/assets/page22/Asset 205.png"), name: "MeningococcalMenB" },
  { imgPath: require("@/assets/page22/Asset 206.png"), name: "Humanpapilloma" },
];
</script>
